import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent, OktaLoginRedirectComponent } from '@okta/okta-angular';
import { FullLayoutComponent } from './Layouts/full-layout/full-layout.component';
import { OnDemandPreloadStrategy } from './shared/services/preloadstrategy';
import { SubNavFullWidthComponent } from './layouts/sub-nav-full-width.component';
import { PrintLayoutComponent } from './print-to-pdf/print-layout/print-layout.component';
import { ApartmentInfoTemplateComponent } from './print-to-pdf/templates/apartment-info-template/apartment-info-template.component';

export const ROUTE_STRATEGY = [OnDemandPreloadStrategy];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'user',
    pathMatch: 'full',
    canActivate: [OktaAuthGuard],

  },
  {
    path: 'implicit/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'login',
    component: OktaLoginRedirectComponent

  },

  {
    path: 'user-profile',
    component: FullLayoutComponent,
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule),
  },
  {
    path: 'building-dashboard',
    component: FullLayoutComponent,
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./building-dashboard/building-dashboard.module').then(m => m.BuildingDashboardModule),
  },
  {
    path: 'registrations-data',
    component: FullLayoutComponent,
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./registrations-data/registrations-data.module').then(m => m.RegistrationsDataModule),
  },
  {
    path: 'buildings',
    component: FullLayoutComponent,
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./buildings/buildings.module').then(m => m.BuildingsModule),
  },
  {
    path: 'notifications',
    component: FullLayoutComponent,
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule),
  },
  {
    path: 'kendo',
    loadChildren: () => import('./shared-kendo/shared-kendo.module').then(m => m.SharedKendoModule),
  },
  {
    path: 'material-design',
    loadChildren: () => import('./shared-materialdesign/shared-material.module').then(m => m.SharedMaterialModule),
  },
  /* {
    path: 'case-application',
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./case-application/case-application.module').then(m => m.CaseApplicationModule)
  }, */
  {
    path: 'case-application',
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./casetype-dashboard/casetype-dashboard.module').then(m => m.CaseTypesDashboardModule)
  },
  {
    path: 'user',
    component: SubNavFullWidthComponent,
    canActivate: [OktaAuthGuard],
    loadChildren: () => import('./user-dashboard/user-dashboard.module').then(m => m.UserDashboardModule)
  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintLayoutComponent,
    children: [ { path: 'apartment/:aptNumber', component: ApartmentInfoTemplateComponent } ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: OnDemandPreloadStrategy,
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
